import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";

import { RoutePathInfo } from "./interface";

export const TabRouterPath = DeprecatedGlobalAppV1Paths;

/**
 * @deprecated
 * This is no longer being maintained.
 * This is only used for logging and for one deprecated hook.
 * We will no longer be maintaining names for routes
 * The routes are the definitive truth, and it is more useful to know the exact route in logs.
 */
export const TabRouterPathInfo: Record<keyof typeof TabRouterPath, RoutePathInfo> = {
  MY_SHIFTS: {
    name: "My Shifts",
  },
  OPEN_SHIFTS: {
    name: "Open Shift Calendar",
  },
  RATINGS_BADGES: {
    name: "Your Badges",
  },
  CHAT: {
    name: "Chat Page",
  },
  ADDRESS: {
    name: "Address View",
  },
  PROFILE_CONTRACT: {
    name: "Contract View",
  },
  MY_SHIFT_DETAIL: {
    name: "Shift Detail Page",
  },
  UNVERIFIED_SHIFTS: {
    name: "Unverified Shifts Page",
  },
  SUCCESS_ONBOARDING: {
    name: "Success Onboarded",
  },
  PAYMENT_SERVICE_ONBOARDING: {
    name: "Onboarding Payment Service",
  },
  UPDATED_CONTRACTOR_AGREEMENT: {
    name: "Updated Contractor Agreement",
  },
  FACILITY_DETAIL: {
    name: "Workplace Detail",
  },
  NEED_HELP: {
    name: "Need Help?",
  },
  HELP_DETAILS: {
    name: "Help Details",
  },
  UPDATE_PROFILE: {
    name: "Update Profile",
  },
  LICENSE_MANAGER: {
    name: "License Manager",
  },
  LICENSE_MANAGER_ADD: {
    name: "Add License",
  },
  LICENSE_DETAILS: {
    name: "License Details Page",
  },
  ADD_LICENSE: {
    name: "Add License",
  },
  LICENSE_RECIPROCITY: {
    name: "License Reciprocity",
  },
  COLLEAGUE_LIST: {
    name: "Colleague List",
  },
  FRIENDS_LIST: {
    name: "Work with Friends",
  },
  SETUP_STRIPE: {
    name: "Setup Stripe",
  },
  NOTIFICATION_CENTER: {
    name: "Notification Center",
  },
  RATE_NEGOTIATIONS: {
    name: "Rate Negotiations",
  },
  CAREER_AGENT: {
    name: "Career Agent",
  },
  WORKPLACE_REFERRALS: {
    name: "Workplace Referrals",
  },
  RATE_NEGOTIATION_TOOL: {
    name: "Rate Negotiation Tool",
  },
  SHIFT_FEEDBACK_RESOLVER: {
    name: "Shift Feedback Resolver",
  },
  CLIPBOARD_GUIDES_CHAT: {
    name: "Clipboard Guides Chat",
  },
};

/**
 * Checks to see if the base path is a shift path.
 * @param pathname Current path
 * @returns true if the path is a shift path
 */
export function isAShiftPath(pathname: string) {
  return (
    pathname.startsWith(TabRouterPath.OPEN_SHIFTS) || pathname.startsWith(TabRouterPath.MY_SHIFTS)
  );
}
